import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getAll from 'utils/getAll'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  setSites: Function
  setValue: Function
  currentCustomer: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    getAll(apiUrls.sites).then((data) => props.setSites(data))
    // fetch the device if edit
    if (props.id !== undefined) {
      loadRecord(apiUrls.centers, props.id).then((data) => {
        props.reset(data)

        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } else {
      //
      props.setValue('site', null)
      props.setDataLoaded(true)
      props.setShowOverlay(false)
    }
  }, [props.currentCustomer])
}

export default useInit
